module.exports = __webpack_public_path__ + "static/img/app_nopen.c8c9314.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app_nopen.png
// module id = CFAq
// module chunks = 73